export default {
  title: 'Bandeja de aprobación',
  subtitle: 'Gestiones de soporte propuestas desde HubSpot',

  lanes: {
    READY_TO_APPROVE: 'Para aprobar',
    NEEDS_DECISION: 'Requiere elegir',
    MANUAL: 'Manual',
  },

  review: {
    tab_label: 'Ejecutadas con aviso',
  },

  filters: {
    action_type: 'Tipo de gestión',
    all_action_types: 'Todos los tipos',
    school_id: 'ID de colegio',
    date_from: 'Desde',
    date_to: 'Hasta',
    search: 'Buscar',
    clear: 'Limpiar filtros',
  },

  action_types: {
    ENROLLMENT_WITHDRAW: 'Retiro de matrícula',
    ENROLLMENT_CHANGE_COURSE: 'Cambio de curso',
    ENROLLMENT_CHANGE_CAMPUS: 'Cambio de sede',
    STUDENT_FIX_PERSONAL_DATA: 'Corrección de datos personales',
    STUDENT_FIX_EMAIL: 'Corrección de correo del alumno',
    PARENT_FIX_EMAIL: 'Corrección de correo del tutor',
    STUDENT_FIX_DNI: 'Corrección de DNI',
    TEACHER_CREATE: 'Alta de docente',
    TEACHER_REASSIGN_COURSE: 'Reasignación de curso a docente',
    SIBLINGS_CROSSED_RECORDS: 'Registros cruzados entre hermanos',
    LICENSE_GRANT: 'Otorgamiento de licencia',
    USER_COMPLETE_AFTER_REDEMPTION: 'Completar usuario tras canje',
    PASSWORD_RESET_TRIGGER: 'Restablecimiento de contraseña',
    ACCESS_DIAGNOSE: 'Diagnóstico de acceso',
    REQUEST_MORE_INFO: 'Solicitud de información adicional',
    CLASSIFY_AND_ROUTE: 'Clasificación y derivación',
    CLOSE_AS_NOISE: 'Cierre sin respuesta',
  },

  resolutions: {
    RESOLVED_UNIQUE: 'Coincidencia única',
    RESOLVED_FUZZY: 'Coincidencia aproximada',
    AMBIGUOUS: 'Ambiguo',
    NOT_FOUND: 'No encontrado',
    PICKED_BY_HUMAN: 'Elegido manualmente',
    DNI_NAME_CONFLICT: 'El DNI pertenece a otra persona',
  },

  target_status: {
    PENDING: 'Pendiente',
    APPLIED: 'Aplicado',
    FAILED: 'Falló',
    SKIPPED: 'Excluido',
  },

  // Estados posibles de `action.status` distintos de PROPOSED (KB-907). Un
  // estado desconocido cae al valor crudo — ver `$te` en la card.
  action_status: {
    EXECUTED: 'Ejecutada',
    EXECUTED_WITH_WARNING: 'Ejecutada con aviso',
    REJECTED: 'Rechazada',
    FAILED: 'Falló',
  },

  // Etiqueta por campo para el diff en lenguaje de negocio (KB-907). Espejo
  // de `ChangeField` en backend-v2.
  change_fields: {
    course: 'Curso',
    campus: 'Sede',
    school: 'Colegio',
    studentEmail: 'Correo del alumno',
    parentEmail: 'Correo del tutor',
    firstName: 'Nombre',
    lastName: 'Apellido',
    lastName2nd: 'Segundo apellido',
    birthDate: 'Fecha de nacimiento',
    dni: 'DNI',
    teacherCourses: 'Cursos del docente',
  },

  counts: {
    empty: 'No hay gestiones en este carril',
    empty_for_type: 'No hay gestiones de tipo "{type}" en este carril.',
  },

  card: {
    ticket: 'Ticket #{id}',
    ticket_created_at: 'Ticket creado el {date}',
    proposed_at: 'Gestión propuesta el {date}',
    evidence_title: 'Lo que dice el ticket',
    view_full_ticket: 'Ver el ticket completo',
    hide_full_ticket: 'Ocultar el ticket completo',
    approval_note_title: 'Verificación previa',
    diagnosis_title: 'Resultado del diagnóstico',
    manual_reason_title: 'Por qué requiere revisión manual',
    changes_title: 'Qué cambia esta gestión',
    changes_empty_value: '(vacío)',
    payload_title: 'Detalle de la gestión',
    targets_title: 'Alumnos/docentes involucrados',
    view_profile: 'Ver ficha',
    candidates_label: 'Elegir entre los candidatos encontrados',
    pick: 'Elegir',
    pick_placeholder: 'Selecciona un candidato',
    picked: 'Candidato elegido',
    approve: 'Aprobar',
    approve_partial: 'Aprobar seleccionados',
    approve_disabled_manual: 'Esta gestión requiere revisión manual: no se puede aprobar desde acá. Rechaza si corresponde, o resuelve el ticket a mano.',
    reject: 'Rechazar',
    no_eligible_targets: 'Ningún alumno/docente quedó resuelto: no hay nada que aprobar todavía.',
    school_id: 'Colegio #{id}',
    school: '{name}',
    reply_draft_title: 'Borrador de respuesta',
    save_draft: 'Guardar borrador',
    execution_warning_title: 'Lo que detectó la verificación después de aplicar',
    undo: 'Deshacer',
    undone_by: 'Deshecho por {by} el {date}',
  },

  batch: {
    select_all: 'Seleccionar todos',
    approve_selected: 'Aprobar seleccionadas ({count})',
    result_success: '{count} gestión(es) aprobada(s)',
    result_partial: '{success} aprobada(s), {failed} no se pudieron aprobar',
  },

  errors: {
    load: 'No se pudieron cargar las gestiones. Inténtalo de nuevo.',
    approve: 'No se pudo aprobar la gestión.',
    reject: 'No se pudo rechazar la gestión.',
    pick: 'No se pudo asignar el candidato elegido.',
    conflict: 'Esta gestión cambió desde que se cargó. Se recargó la bandeja.',
    saveDraft: 'No se pudo guardar el borrador. Inténtalo de nuevo.',
    undo: 'No se pudo deshacer la gestión.',
  },

  success: {
    approved: 'Gestión aprobada',
    rejected: 'Gestión rechazada',
    picked: 'Candidato asignado',
    draftSaved: 'Borrador guardado',
    undone: 'Gestión deshecha',
  },

  pagination: {
    per_page: 'Por página',
  },

  // Tickets del carril Manual sin ninguna gestión propuesta (KB-907). Sin
  // botones de aprobar/rechazar: son tickets que hay que atender a mano.
  unprocessed: {
    title: 'Tickets que no se pudieron interpretar',
    empty: 'No hay tickets sin interpretar en este carril.',
    reason_title: 'Por qué no se pudo interpretar',
    ticket_date: 'Ticket creado el {date}',
    form_data: 'Formulario: {name} — DNI {dni}',
  },
};
